<template>
  <div class="modal" tabindex="-1" role="dialog" v-if="isVisible">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">作業実施確認</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div v-if="isWorkDtRequired">
            <label for="modalWorkDt" class="form-label">
              作業日 <span class="badge text-bg-danger">必須</span>
            </label>
            <input
              id="modalWorkDt"
              v-model="temporaryWorkData.work_dt"
              type="date"
              class="form-control"
              max="2099-12-31"
            >
            <div v-if="workDtError" class="text-danger mt-2">{{ workDtError }}</div>
          </div>
          <div v-else>
            <p class="mb-0">作業日は登録済みです。このまま実施登録します。</p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">キャンセル</button>
          <button type="button" class="btn btn-dark" @click="registerWorkUnworked">
            未実施登録
          </button>
          <button type="button" class="btn btn-primary" @click="registerWorkCompleteCheck">
            確認登録
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { workCompleteCheck, workUnworkedRegist } from '@/api/axios';

export default {
  emits: ['onClose'],
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();
    const isVisible = ref(false);
    const temporaryWorkData = reactive({
      id: null,
      year: null,
      month: null,
      confirm_worked: null,
      confirm_worked_dt: new Date().toISOString().substring(0, 10), // デフォルトで今日の日付
      work_dt: '',
    });
    const isWorkDtRequired = ref(false);
    const workDtError = ref('');

    // 呼び出し元を保持するための変数
    const callerSource = ref('');

    const show = ({ temporaryWorkId, year, month, source, workDt }) => {
      temporaryWorkData.id = temporaryWorkId;
      temporaryWorkData.year = year;
      temporaryWorkData.month = month;
      temporaryWorkData.confirm_worked = true;
      temporaryWorkData.confirm_worked_dt = new Date().toISOString().substring(0, 10); // デフォルト日付
      temporaryWorkData.work_dt = workDt || '';
      isWorkDtRequired.value = !temporaryWorkData.work_dt;
      workDtError.value = '';
      callerSource.value = source; // 呼び出し元を保持
      isVisible.value = true;
    };

    const closeModal = () => {
      workDtError.value = '';
      isVisible.value = false;
    };

    const registerWorkCompleteCheck = async () => {
      if (isWorkDtRequired.value && !temporaryWorkData.work_dt) {
        workDtError.value = '作業日を入力してください';
        return;
      }

      try {
        await workCompleteCheck(temporaryWorkData.id, temporaryWorkData);
        store.dispatch('setFlashMessage', { message: '作業実施確認完了！', type: 'success' });
        // 呼び出し元に応じてパスを変更
        const path = '/temporary-works';

        router.push({
          path,
          query: { year: temporaryWorkData.year, month: temporaryWorkData.month },
        });
        closeModal();
        emit('onClose'); // 親コンポーネントに通知
      } catch (error) {
        console.error('作業実施確認登録エラー:', error);
      }
    };

    const registerWorkUnworked = async () => {
      try {
        await workUnworkedRegist(temporaryWorkData.id);
        store.dispatch('setFlashMessage', { message: '未実施登録完了！', type: 'success' });
        const path = '/temporary-works';

        router.push({
          path,
          query: { year: temporaryWorkData.year, month: temporaryWorkData.month },
        });
        closeModal();
        emit('onClose');
      } catch (error) {
        console.error('未実施登録エラー:', error);
      }
    };

    return {
      isVisible,
      temporaryWorkData,
      isWorkDtRequired,
      workDtError,
      show,
      closeModal,
      registerWorkUnworked,
      registerWorkCompleteCheck,
    };
  },
};
</script>

<style scoped>
.modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  max-width: 500px;
}
</style>
